import getConfig from 'next/config';
import querystring, { type ParsedUrlQueryInput } from 'querystring';

import { ServiceNames } from './serviceNames';

const {
    serverRuntimeConfig: { apiUrl },
} = getConfig();

export const offerInfoService = {
    resource: ServiceNames.OFFER_INFO_SERVICE,

    read: async (
        _req: unknown,
        _resource: unknown,
        params: ParsedUrlQueryInput,
        _config: unknown,

        callback: (error: unknown, response: unknown) => unknown
    ): Promise<void> => {
        const url = `${apiUrl}/offer?${params ? querystring.stringify(params) : ''}`;

        try {
            const response = await fetch(url);
            const json = await response.json();

            callback(null, json);
        } catch (e) {
            callback(e, { reason: `failed fetching from ${url}` });
        }
    },
};
